import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';

import { MainTemplate } from 'templates';
import { PATHS } from 'router/config';

import * as S from './PandaDocProvisioning.styled';
import { FoldersList } from './FoldersList';
import { FolderScreen } from './FolderScreen';

/**
 * PandaDoc provisioning section — turns signed PandaDoc contracts into
 * students in a group. Two screens: folder list and a single folder
 * (tz-backend.md §4). Group creation reuses the standard `AddGroupPopup`.
 */
export const PandaDocProvisioning = memo(() => (
  <MainTemplate>
    <S.Wrapper>
      <Switch>
        <Route
          exact
          path={PATHS.debtorsPandadocProvisioning}
          component={FoldersList}
        />
        <Route
          path={PATHS.debtorsPandadocProvisioningFolder}
          component={FolderScreen}
        />
      </Switch>
    </S.Wrapper>
  </MainTemplate>
));
